import React, { useState } from "react";
import {
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import NumbersIcon from "@mui/icons-material/Numbers";
import BolHeader from "./BolHeader";
import generatePDFBol from "../tools/generatePDFBol";
import { useNavigate } from "react-router-dom";

export default function BillOfLadingForm() {
  const navigate = useNavigate();
  const [date, setDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(today.getDate()).padStart(2, "0")}`;
  });

  const [nameST, setNameST] = useState("");
  const [nameSF, setNameSF] = useState("");
  const [nameTP, setNameTP] = useState("");
  const [addressST, setAddressST] = useState("");
  const [addressSF, setAddressSF] = useState("");
  const [addressTP, setAddressTP] = useState("");
  const [cityStateZSF, setCSZSF] = useState("");
  const [cityStateZST, setCSZST] = useState("");
  const [cityStateZTP, setCSZTP] = useState("");
  const [instructions, setInstructions] = useState("");
  const [bolNumber, setBolNumber] = useState("");
  const [carrierName, setCarrierName] = useState("");
  const [trailerNumber, setTrailerNumber] = useState("");
  const [sealNumber, setSealNumber] = useState("");
  const [rows, setRows] = useState([{ description: "", weight: "", qty: "" }]);
  const [orderNumber, setOrderNumber] = useState("");
  const [notes, setNotes] = useState("");

  const addRow = () => {
    setRows([...rows, { description: "", weight: "", qty: "" }]);
  };

  const updateRow = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value.toUpperCase();
    setRows(newRows);
  };

  const deleteRow = (index) => {
    const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(newRows);
  };

  const handleBolSubmit = (invoice) => {
    generatePDFBol(invoice, date, orderNumber);
    setOrderNumber("");
  };

  return (
    <>
      <Button onClick={() => navigate("/")}>
        <ArrowBackIcon /> Main menu
      </Button>
      <BolHeader
        date={date}
        setDate={setDate}
        orderNumber={orderNumber}
        onOrderNumberChange={setOrderNumber}
      ></BolHeader>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleBolSubmit({
            nameST,
            nameSF,
            nameTP,
            addressST,
            addressSF,
            addressTP,
            cityStateZSF,
            cityStateZST,
            cityStateZTP,
            instructions,
            rows,
            bolNumber,
            carrierName,
            trailerNumber,
            sealNumber,
            notes,
          });
          console.log(notes);
          setNameST("");
          setNameSF("");
          setNameTP("");
          setAddressSF("");
          setAddressST("");
          setAddressTP("");
          setCSZSF("");
          setCSZST("");
          setCSZTP("");
          setInstructions("");
          setRows([{ description: "", weight: "", qty: "" }]);
          setBolNumber("");
          setCarrierName("");
          setTrailerNumber("");
          setSealNumber("");
          setNotes("");
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            fontFamily: "Lato, sans-serif",
          }}
        >
          <TableContainer component={Paper} style={{ width: "48%" }}>
            <Table size="small">
              <TableHead
                style={{
                  background: "black",
                  textTransform: "uppercase",
                }}
              >
                <TableRow>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Ship from
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Name"
                      variant="standard"
                      value={nameSF}
                      onChange={(e) => setNameSF(e.target.value.toUpperCase())}
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Address"
                      variant="standard"
                      value={addressSF}
                      onChange={(e) =>
                        setAddressSF(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      multiline
                      rows={2}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="City/State/zip"
                      variant="standard"
                      value={cityStateZSF}
                      onChange={(e) => setCSZSF(e.target.value.toUpperCase())}
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Table size="small">
              <TableHead
                style={{
                  background: "black",
                  textTransform: "uppercase",
                }}
              >
                <TableRow>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Ship to
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Name"
                      variant="standard"
                      value={nameST}
                      onChange={(e) => setNameST(e.target.value.toUpperCase())}
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Address"
                      variant="standard"
                      value={addressST}
                      onChange={(e) =>
                        setAddressST(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      multiline
                      rows={2}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="City/State/zip"
                      variant="standard"
                      value={cityStateZST}
                      onChange={(e) => setCSZST(e.target.value.toUpperCase())}
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Table size="small">
              <TableHead
                style={{
                  background: "black",
                  textTransform: "uppercase",
                }}
              >
                <TableRow>
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Third party freight charges bill to
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Name"
                      variant="standard"
                      value={nameTP}
                      onChange={(e) => setNameTP(e.target.value.toUpperCase())}
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Address"
                      variant="standard"
                      value={addressTP}
                      onChange={(e) =>
                        setAddressTP(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      multiline
                      rows={2}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="City/State/zip"
                      variant="standard"
                      value={cityStateZTP}
                      onChange={(e) => setCSZTP(e.target.value.toUpperCase())}
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Special instructions"
                      variant="standard"
                      value={instructions}
                      onChange={(e) =>
                        setInstructions(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      multiline
                      rows={4}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <TableContainer component={Paper} style={{ width: "48%" }}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Bill of Landing Number"
                      variant="standard"
                      value={bolNumber}
                      onChange={(e) =>
                        setBolNumber(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                        startAdornment: (
                          <NumbersIcon style={{ fontSize: 16 }}></NumbersIcon>
                        ),
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      required
                      label="Carrier name"
                      variant="standard"
                      value={carrierName}
                      onChange={(e) =>
                        setCarrierName(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                    <TextField
                      required
                      label="MC#"
                      variant="standard"
                      value={trailerNumber}
                      onChange={(e) =>
                        setTrailerNumber(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                    <TextField
                      required
                      label="USDOT#"
                      variant="standard"
                      value={sealNumber}
                      onChange={(e) =>
                        setSealNumber(e.target.value.toUpperCase())
                      }
                      style={{ width: "100%" }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            fontFamily: "Lato, sans-serif",
            flexDirection: "column",
          }}
        >
          <TableContainer component={Paper} style={{ width: "100%" }}>
            <TableRow>
              <TableCell>
                <TextField
                  label="Notes"
                  variant="standard"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value.toUpperCase())}
                  style={{ width: "100%" }}
                  multiline
                  rows={4}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
          </TableContainer>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            fontFamily: "Lato, sans-serif",
            flexDirection: "column",
          }}
        >
          <TableContainer component={Paper} style={{ width: "100%" }}>
            <Table size="small">
              <TableHead style={{ textTransform: "uppercase" }}>
                <TableRow>
                  <TableCell
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    qty
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    weight
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    commodity description
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <TextField
                        required
                        label=""
                        variant="standard"
                        value={row.qty}
                        type="number"
                        onChange={(e) =>
                          updateRow(index, "qty", e.target.value)
                        }
                        style={{ width: "100%" }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        required
                        label=""
                        variant="standard"
                        value={row.weight}
                        onChange={(e) =>
                          updateRow(index, "weight", e.target.value)
                        }
                        style={{ width: "100%" }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        required
                        label=""
                        variant="standard"
                        value={row.description}
                        onChange={(e) =>
                          updateRow(index, "description", e.target.value)
                        }
                        style={{ width: "100%" }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => deleteRow(index)}
                      >
                        <DeleteIcon></DeleteIcon>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ marginTop: "10px" }}>
            <Button onClick={addRow} variant="contained">
              Add
            </Button>
          </div>
        </div>

        <Button type="submit" variant="outlined">
          Save
        </Button>
      </form>
    </>
  );
}
